export const SearchValorantChannelsPage = () => {
  return <>Search</>
}
